import CustomersKpis from "./kpis";
import CustomerOnboardingGraph from "./onboardingGraph"
import CustomerRejectionsGraph from "./rejectionsGraph"
const CustomersGraph = () => {
    const renderCharts = () => {
        return (
            <div className="grid md:grid-cols-2 gap-x-5 mt-7 max-sm:overflow-auto">
                <h3 className='text-lg font-medium text-subTextColor mb-1.5 hidden md:block'>Onboarding</h3>
                <h3 className='text-lg font-medium text-subTextColor mb-1.5 hidden md:block'>KYC States</h3>
                <div className="border bg-chartimg !border-cardBorder rounded-md p-4 drop-shadow-sm bg-blueimg mb-7 md:mb-0">
                    <div className="kpi-section-style h-full barchart-section mb-6">
                    <h3 className='text-lg font-medium text-subTextColor mb-1.5 md:hidden block'>Onboarding</h3>
                        <CustomerOnboardingGraph title={'Card Transactions'} seriesKey={"transactionsModels"} />
                    </div>
                </div>
                <div className="border bg-chartimg !border-cardBorder rounded-md p-4 drop-shadow-sm bg-blueimg mb-7 md:mb-0">
                    <div className="kpi-section-style h-full barchart-section  mb-6">
                    <h3 className='text-lg font-medium text-subTextColor mb-1.5 md:hidden block'>KYC States</h3>
                        <CustomerRejectionsGraph />
                    </div>
                </div>
            </div>
        );
    };
    return (
        <div className="">
                <CustomersKpis />
                {renderCharts()}
        </div>
    );
};
export default CustomersGraph;
